import React from "react";
import ProductList from "./ProductList";
import useUpdateGroupListings from "../../hooks/useUpdateGroupListings";

const ProductGroupList = ({ slider, locationState, customHTML }) => {
  const { currentPage, allPages, productsInfo, productsLoadingStatus } =
    useUpdateGroupListings(locationState);


  return (
    <ProductList
      slider={slider}
      currentPage={currentPage}
      allPages={allPages}
      productsInfo={productsInfo}
      productsLoadingStatus={productsLoadingStatus}
      locationState={locationState}
      customHTML={customHTML}
    />
  );
};

export default ProductGroupList;
